module.exports = __webpack_public_path__ + "static/img/01.37080d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/commodity/03/01.jpg
// module id = HFTU
// module chunks = 0